import { render, staticRenderFns } from "./DoubleList.vue?vue&type=template&id=3746d79a&scoped=true&"
import script from "./DoubleList.vue?vue&type=script&lang=js&"
export * from "./DoubleList.vue?vue&type=script&lang=js&"
import style0 from "./DoubleList.vue?vue&type=style&index=0&id=3746d79a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3746d79a",
  null
  
)

export default component.exports